import { useCallback, useEffect, useState } from 'react'

export const useShowWarning = () => {
  const [isWarningOpen, setIsWarningOpen] = useState(false)

  const showWarning = useCallback((value: boolean) => {
    setIsWarningOpen(value)
  }, [])

  useEffect(() => {
    if (isWarningOpen) {
      const timer = setTimeout(() => {
        setIsWarningOpen(false)
      }, 4000)

      return () => clearTimeout(timer)
    } else {
      setIsWarningOpen(false)
    }
  }, [isWarningOpen])

  return { isWarningOpen, showWarning }
}
